// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RG8xA","clinicsSelect":"styles_clinicsSelect__2kWGE"};